import { Data, AxiosInstance, API } from './types';
import { parseList } from './utils';

const getAddressData = (api: AxiosInstance) => ({
  getAddress: async (query: string, token: string): Promise<Data> => {
    const { data } = await api.post(
      API,
      { query },
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      },
    );
    return parseList(data.suggestions);
  },
});

const getCitizenshipData = (api: AxiosInstance) => ({
  getCitizenship: async (): Promise<Data> => {
    const { data } = await api.get('getDictionary/countries');
    return data;
  },
});

const dictionaryService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getAddressData(api),
    ...getCitizenshipData(api),
  };
};

export default dictionaryService;



// WEBPACK FOOTER //
// ./src/services/dadata/dadataService.ts